import Vue from "vue";
import bgImg from "@/directives/bgImg";

Vue.use(bgImg);

